import React, { Component } from 'react';
import Constants from '../../../../definitions/constants';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import toastr from 'toastr';

import Select from './select';
import TextBox from './textBox';

class SelectList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: ""
    };
  }
  
  handleOnChangeTopControls = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    this.setState({
      searchText: value
    });
  };
  
  handleAddButtonClick = (event) => {
    if(this.addItemInput) {
      this.addItemInput.focus();
    }
  };

  render() {
    const {
      className,
      values,
      options,
      onChange,
      labelLocale,
      addSelectLocale,
      searchSelectLocale,
      noMoreOptionsLocale,
      additionalControls,
      valueAccesor,
      labelAccesor,
      hideList,
      disabled,
      connector,
    } = this.props;
    const dataPath = this.props["data-path"];
    let valuesMap = {};
    let noOptionsLeft = false;
    if(values && options) {
      for(var i=0; i < values.length; i++) {
        valuesMap[values[i][valueAccesor]] = true;
      }
      noOptionsLeft = !connector ? 
      ((options.length - 1) <= Object.keys(valuesMap).length ? true : false) :
      ((options.length) <= Object.keys(valuesMap).length ? true : false);
    }
    return (
      <div className={"custom-input free-text-list select-list" + (className ? " " + className : "") + (!searchSelectLocale ? " select-list-no-search" : "")}>
        <div className="free-text-list-label">
          {labelLocale}
          {!disabled && (<i className="fas fa-plus-circle" onClick={this.handleAddButtonClick}/>)}
          {additionalControls}
        </div>
        {(!hideList && searchSelectLocale) && (
          <TextBox 
            className="top_controls_search"
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            value={this.state.searchText}
            onChange={this.handleOnChangeTopControls}
            labelLocale={searchSelectLocale}
          />
        )}
        {!hideList && (
          <div className="free-text-list-list-wrapper">
            {values && values.map((item,i) => {
                if(!this.state.searchText=="" && 
                !item[this.props.labelAccesor].toUpperCase().indexOf(this.state.searchText.toUpperCase()) > -1) {
                  return null;
                }
                return (
                  <div key={i} className="free-text-list-list-item">
                    <div className="free-text-list-list-item-inner" title={item[this.props.labelAccesor]}>{item[this.props.labelAccesor]}</div>
                    {!disabled && (
                      <div className="free-text-list-list-item-action-buttons">
                        <i 
                          className="fas delete-action fa-trash"                          
                          data-index={i}
                          data-delete={"true"}
                          data-selectlist={"true"}
                          data-path={dataPath}
                          onClick={onChange}
                        />
                      </div>
                    )}
                  </div>
                );           
            })}
            {(!noOptionsLeft) ? (
              <div className="free-text-list-list-item free-text-list-list-item-add">
                <div className="free-text-list-list-item-inner">
                  {!disabled && (
                    <Select 
                      ref={(input) => { this.addItemInput = input; }}
                      className="free-text-list-list-add-item"
                      value={""}
                      labelLocale={addSelectLocale}
                      options={options ? options.filter(option => !(option.value in valuesMap)) : []}                  
                      data-selectlist={"true"}
                      data-path={dataPath}
                      onChange={onChange}
                    />
                  )}
                </div>
              </div>
            ) : (              
              <div className="free-text-list-list-item free-text-list-list-item-add">
                {!disabled && (
                  <div className="free-text-list-list-item-inner message" title={noMoreOptionsLocale}>
                    {noMoreOptionsLocale}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default SelectList;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/selectList.jsx